export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./RadioGroup.vue?vue&type=template&id=3ec2a420&"


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/lk/form/RadioGroup.vue?vue&type=template&id=3ec2a420&
// module id = 1733
// module chunks = 0